<mat-form-field
    appearance="outline"
    [floatLabel]="floatLabel"
    [ngClass]="{ simpleInput: simpleInput, 'full-width': fullWidth}"
>
    <mat-label *ngIf="!simpleInput">
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>

    <input
        #input
        matInput
        [type]="type"
        [placeholder]="placeholder"
        autocomplete="nothing"
        [formControl]="useIndependentControl?  control : aumFormControl"
        [errorStateMatcher]="errorStateMatcher"
        (blur)="recalculateErrorState()"
        (input)="recalculateErrorState()"
        (focus)="onFocus()"
    />
    <mat-icon
        *ngIf="shouldDisplayWarningTriangle"
        matSuffix
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>

    <mat-error>
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
